import React, { useState, createContext } from 'react';

export const CameraContext = createContext({
  open: false,
  containerName: null,
  setOpen: () => {},
  setContainerName: () => {},
  image: null,
  setImage: () => {},
  isLoading: false,
  setLoading: () => {},
  state: null,
  setState: () => null,
});

export const CameraProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [containerName, setContainerName] = useState(null);
  // URL image
  const [image, setImage] = useState(null);
  const [state, setState] = useState({
    fileList: [
      //eg: images
      // {
      //   uid: '-1',
      //   name: 'xxx.png',
      //   status: 'done',
      //   url: 'http://www.baidu.com/xxx.png',
      // },
    ],
  });

  return (
    <CameraContext.Provider
      value={{
        open,
        setOpen,
        containerName,
        setContainerName,
        image,
        setImage,
        isLoading,
        setLoading,
        state,
        setState,
      }}
    >
      {children}
    </CameraContext.Provider>
  );
};
